import { sendCustomEvent } from './util/eventClient';

function getEventInfo(popupType) {
  const baseEventInfo = {
    eventParams: { location: 'content_home' },
  };
  switch (popupType) {
    // "결제 방법 선택" 팝업의 등장 이벤트 정보
    // "대여"와 "소장" 중 하나를 선택하는 팝업
    case 'js_select_purchase_type_popup':
      return {
        ...baseEventInfo,
        eventName: 'checkout_popup_view_purchase_option',
      };
    // "결제하기" 팝업의 등장 이벤트 정보
    case 'js_serial_checkout_cash_and_point_popup':
      return {
        ...baseEventInfo,
        eventName: 'checkout_popup_view_purchase',
      };
    // 결제 전 결제할 금액과 사용자가 보유한 포인트 혹은 캐시를 비교하였을 때 포인트와 캐시가 부족한 경우
    case 'js_serial_checkout_by_others_popup':
      return {
        ...baseEventInfo,
        eventName: 'checkout_popup_view_cash_alert',
      };
    // 무료로 보기 팝업 오픈 (단일 회차)
    case 'js_serial_free_rent_coupon_popup':
      return {
        ...baseEventInfo,
        eventName: 'checkout_popup_view_free_coupon',
      };
    // 무료로 보기 팝업 오픈 (여러 회차)
    // 작품홈에만 있는 이벤트여서, location 파라미터는 필요 없음
    case 'js_multiple_serial_free_rent_coupons_popup':
      return {
        eventName: 'checkout_popup_view_free_rental',
      };
    // 과거에 대여했지만, 만료된 작품을 다시 대여하려고 할 때 나타나는 팝업
    case 'js_already_exists_popup':
      return {
        ...baseEventInfo,
        eventName: 'checkout_popup_view_rerental',
      };

    default:
      return {
        eventName: 'UNKNOWN_POPUP_EVENT',
      };
  }
}

function sendPopupViewEvent(popupType) {
  const { eventName, eventParams } = getEventInfo(popupType);
  if (eventName === 'UNKNOWN_POPUP_EVENT') {
    return;
  }
  sendCustomEvent(eventName, eventParams);
}

$(() => {
  // IntersectionObserver 설정
  // 팝업이 화면에 보일 때 이벤트를 보내기 위한 설정
  const observer = new IntersectionObserver(entries => {
    const entry = entries[0]; // 각 팝업에 대해서만 관찰하고 있으므로 첫 번째 entry만 체크
    if (entry.isIntersecting) {
      const popupId = $(entry.target).attr('id');
      sendPopupViewEvent(popupId); // 팝업이 화면에 보이면 이벤트를 보냄
    }
  });

  $('#serial_popup > .popup_wrapper').each(function () {
    observer.observe(this); // 각 팝업을 관찰
  });
});



// WEBPACK FOOTER //
// ./event_checkout_popup.js